// 書面表示選択
import { atom } from 'recoil';
import { DocumentStateType } from '@/mobile/types/api/mypage/document';

/**
 * 書類関連のグローバルステート
 * 契約関連書類のダウンロードや表示に必要な状態を管理する。
 * 書類一覧や個別書類の取得結果を保持する。
 */
export const documentState = atom<DocumentStateType>({
  key: 'DocumentState',
  default: {
    can_display: false,
    document_info: {
      contract_info: {
        // SIM電話番号
        sim_phone_number: '',
        // 契約年月日
        contract_date: '',
        // 契約者姓（漢字）
        last_name: '',
        // 契約者名（漢字）
        first_name: '',
        // 生年月日
        birthday: '',
        // サービス利用開始日
        service_start_date: '',
      },
      service_info: {
        // サービス名称
        service_name: '',
        // サービス基本料金プラン名称
        service_basic_price_plan_name: '',
        // 基本料金
        basic_price: '',
        // 事務手数料
        administration_fee: '',
        // SIMカード準備料／eSIM発行手数料
        sim_preparation_fee: '',
        // ショートメッセージ通信料
        sms_charge: '',
        // 通話料
        call_charge: '',
      },
      condition_info: {
        // 契約書面（契約変更・解放の条件など）情報
        conditions: [],
      },
      mypage_info: {
        // マイページURL
        mypage_url: '',
        // マイページパスワード再発行URL
        password_reissue_url: '',
      },
      option_info: {
        // 契約書面（オプション）情報
        conditions: [],
      },
      campaign_info: {
        // 契約書面（キャンペーン）情報
        conditions: [],
      },
      payment_info: {
        // 支払方法
        payment_type: '',
        // 請求時期
        billing_timing: '',
      },
      contact_us_info: {
        // 窓口名
        contact_name: '',
        // 電話番号
        telephone_number: '',
        // 受付時間
        reception_time: '',
      },
    },
  },
});

export const defaultDocument = {
  contract_info: {
    // SIM電話番号
    sim_phone_number: '',
    // 契約年月日
    contract_date: '',
    // 契約者姓（漢字）
    last_name: '',
    // 契約者名（漢字）
    first_name: '',
    // 生年月日
    birthday: '',
    // サービス利用開始日
    service_start_date: '',
  },
  service_info: {
    // サービス名称
    service_name: '',
    // サービス基本料金プラン名称
    service_basic_price_plan_name: '',
    // 基本料金
    basic_price: 0,
    // 事務手数料
    administration_fee: 0,
    // SIMカード準備料／eSIM発行手数料
    sim_preparation_fee: 0,
    // ショートメッセージ通信料
    sms_charge: 0,
    // 通話料
    call_charge: 0,
  },
  condition_info: {
    // 契約書面（契約変更・解放の条件など）情報
    conditions: [],
  },
  mypage_info: {
    // マイページURL
    mypage_url: '',
    // マイページパスワード再発行URL
    password_reissue_url: '',
  },
  option_info: {
    // 契約書面（オプション）情報
    conditions: [],
  },
  campaign_info: {
    // 契約書面（キャンペーン）情報
    conditions: [],
  },
  payment_info: {
    // 支払方法
    payment_type: '',
    // 請求時期
    billing_timing: '',
  },
  contact_us_info: {
    // 窓口名
    contact_name: '',
    // 電話番号
    telephone_number: '',
    // 受付時間
    reception_time: '',
  },
};
